import type {Identified} from 'src/typings';
import type {UIcons} from 'shared/ui-widgets/uicons/types';

export const TABS_CONTEXT_NAME = 'headlessui-tabs-context';

export interface HeadlessTabsApiData {
    tabs: HTMLElement[];
    selectedIndex: number;
    setSelectedIndex: (value: number) => void;
}

export type TabsetId = `tab-${string}`;
export type TabsetPanelId = `tab-panel-${string}`;

export interface TabButton extends Identified<TabsetId> {
    label: string;
    icon?: UIcons;
    disabled?: boolean;
    editPermissionFond?: number;
    showPermissionFond?: number;
    tabPageWithoutPadding?: boolean;
    tabPageContainerClass?: string;
}